import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { ProjectItem } from "../Types";
import PartView from "./PartView";
import 'react-tabs/style/react-tabs.css';
import TrackView from "./TrackView";

export default function ItemView(props: { item: null | ProjectItem, partindex: number, setPartindex: any }) {

  const partnames = props.item != null ? props.item.parts.map(part => part.name) : [];

  if (props.item == null)
    return (
      <>
        <h1>Välkommen!</h1>
        <p>Här hittar du ljudfiler för aktuella körprojekt.</p>
        <p>Ange det lösenord som du har fått av din körledare i lösenordsfältet ovan till höger, och klicka därefter på Logga in-knappen.</p>
      </>
    );

  return (
    <>
      <h1>{props.item.title}</h1>
      <p>Här hittar du ljudfiler för {props.item.title}. Välj din stämma genom att klicka på flikarna här under.</p>
      {props.item.info && <p><i>{props.item.info}</i></p>}

      <Tabs defaultIndex={props.partindex} onSelect={index => props.setPartindex(index)}>
        <TabList>
          {partnames.map((name) => (
            <Tab key={name}>{name}</Tab>
          ))}
        </TabList>
        {props.item.parts.map((part) => (
          <TabPanel >
            <div className="Flex Column Pad1" style={{ width: "100%" }}>
              {part.tracks.map(track => <TrackView key={track.title} track={track} />)}
            </div>
          </TabPanel>
        ))}

      </Tabs>


    </>
  );
}
